import { render, staticRenderFns } from "./VisibilityBadge.vue?vue&type=template&id=707a576e&scoped=true"
import script from "./VisibilityBadge.vue?vue&type=script&lang=js"
export * from "./VisibilityBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a576e",
  null
  
)

export default component.exports